/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedResultSalesOrderItemSummary,
  SortDirection,
} from '../models/index';
import {
    PagedResultSalesOrderItemSummaryFromJSON,
    PagedResultSalesOrderItemSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetSalesOrderItemSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    productNumber?: string;
    fullTextQuery?: string;
    sortBySalesOrderCreatedAt?: SortDirection;
    sortByCustomerOrderNumber?: SortDirection;
    sortByAvailability?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByPricePerUnit?: SortDirection;
    sortByTotal?: SortDirection;
    sortByDiscount?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
    sortByCustomerReference?: SortDirection;
}

/**
 * 
 */
export class SalesOrderItemResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getSalesOrderItemSummariesOfCurrentRetailer without sending the request
     */
    async getSalesOrderItemSummariesOfCurrentRetailerRequestOpts(requestParameters: GetSalesOrderItemSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['productNumber'] != null) {
            queryParameters['productNumber'] = requestParameters['productNumber'];
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['sortBySalesOrderCreatedAt'] != null) {
            queryParameters['sortBySalesOrderCreatedAt'] = requestParameters['sortBySalesOrderCreatedAt'];
        }

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortByAvailability'] != null) {
            queryParameters['sortByAvailability'] = requestParameters['sortByAvailability'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByPricePerUnit'] != null) {
            queryParameters['sortByPricePerUnit'] = requestParameters['sortByPricePerUnit'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByDiscount'] != null) {
            queryParameters['sortByDiscount'] = requestParameters['sortByDiscount'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/sales-order-item`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemSummariesOfCurrentRetailerRaw(requestParameters: GetSalesOrderItemSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedResultSalesOrderItemSummary>> {
        const requestOptions = await this.getSalesOrderItemSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedResultSalesOrderItemSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getSalesOrderItemSummariesOfCurrentRetailer(requestParameters: GetSalesOrderItemSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedResultSalesOrderItemSummary> {
        const response = await this.getSalesOrderItemSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
